import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useDialogLoadingButton } from '../_hooks/useDialogLoadingButton';
import { IConfirmDialogProps } from './ConfirmDialog.interface';

export const ConfirmDialog: FunctionComponent<IConfirmDialogProps> = (props) => {
  const { open, payload, onClose } = props;

  const { t } = useTranslation();

  const {
    title = t('text:common.dialog.confirm.title'),
    okText = t('text:common.button.ok'),
    cancelText = t('text:common.button.cancel'),
    msg,
    severity,
  } = payload;

  const cancelButtonProps = useDialogLoadingButton(() => onClose(false));
  const okButtonProps = useDialogLoadingButton(() => onClose(true));

  return (
    <Dialog
      maxWidth={'xs'}
      fullWidth={true}
      open={open}
      onClose={() => onClose(false)}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ whiteSpace: 'pre-line' }}>{msg}</DialogContent>
      <DialogActions>
        <Button sx={{ textTransform: 'none' }}
          autoFocus={true} disabled={!open} color={'secondary'}
          {...cancelButtonProps}>
          {cancelText}
        </Button>
        <Button sx={{ textTransform: 'none' }} color={severity} disabled={!open} {...okButtonProps}>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
